import { render } from "./EmptyListItem.vue?vue&type=template&id=3fba1072"
import script from "./EmptyListItem.vue?vue&type=script&lang=js"
export * from "./EmptyListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__